import { useCallback } from "react";
import { gql } from "@apollo/client";
import { CommsOptInEventType } from "@src/types.generated";
import { useRecordCommsOptInEventMutation } from "./useRecordCommsOptInEvent.generated";

const useRecordCommsOptInEvent = (): ((type: CommsOptInEventType) => void) => {
  const [recordCommsOptInEvent] = useRecordCommsOptInEventMutation({
    onError: () => undefined,
  });
  return useCallback(
    (type: CommsOptInEventType) => {
      void recordCommsOptInEvent({ variables: { type } });
    },
    [recordCommsOptInEvent],
  );
};

gql`
  mutation RecordCommsOptInEvent($type: CommsOptInEventType!) {
    recordCommsOptInEvent(type: $type) {
      success
    }
  }
`;

export default useRecordCommsOptInEvent;
